import { languageMenuStyles } from "@insite/content-library/Widgets/Common/LanguageMenu";
import { css } from "styled-components";

languageMenuStyles.languageWrapper = {
    ...languageMenuStyles.languageWrapper,
};

languageMenuStyles.languageSelect = {
    ...languageMenuStyles.languageSelect,
    cssOverrides: {
        formInputWrapper: css`
            width: 135px;
            P #languageMenu {
                box-shadow: none;
            }
        `,
        inputSelect: css`
            border: none;
            text-transform: uppercase;
        `,
    },
};

languageMenuStyles.languageIcon = {
    ...languageMenuStyles.languageIcon,
    css: css`
        margin-right: 5px;
    `,
};
